<template>
  <ContentWrap
    ><el-form :inline="true"
      ><el-form-item label="昵称"><el-input v-model="q.nickname" clearable /></el-form-item
      ><el-form-item label="认证状态"
        ><el-select v-model="q.certificationStatus" clearable class="!w-150px"
          ><el-option label="未认证" :value="0" /><el-option label="待审核" :value="2" /><el-option
            label="审核中"
            :value="10" /><el-option label="已认证" :value="20" /><el-option
            label="已拒绝"
            :value="30" /></el-select></el-form-item
      ><el-button type="primary" @click="query">查询</el-button
      ><el-button @click="resetQuery">重置</el-button></el-form
    ></ContentWrap
  ><ContentWrap
    ><el-table v-loading="loading" :data="list" border
      ><el-table-column prop="id" label="编号" width="80" /><el-table-column
        label="创作者"
        min-width="170"
        ><template #default="{ row }"
          ><div class="flex items-center gap-2"
            ><el-avatar :size="32" :src="row.avatarUrl" /><span>{{
              row.nickname || '--'
            }}</span></div
          ></template
        ></el-table-column
      ><el-table-column prop="organizationName" label="所属机构" min-width="140"
        ><template #default="{ row }">{{ row.organizationName || '--' }}</template></el-table-column
      ><el-table-column prop="certificationType" label="认证类型" /><el-table-column
        label="认证状态"
        ><template #default="{ row }"
          ><el-tag :type="certificationType(row.certificationStatus)">{{
            names[row.certificationStatus] || '未认证'
          }}</el-tag></template
        ></el-table-column
      ><el-table-column prop="followerCount" label="粉丝" /><el-table-column
        prop="creditScore"
        label="信用分"
      /><el-table-column prop="growthScore" label="成长值" /><el-table-column
        prop="creatorLevel"
        label="等级"
      /><el-table-column label="发布权限"
        ><template #default="{ row }"
          ><el-switch
            v-model="row.publishEnabled"
            @change="Api.creatorUpdate(row)" /></template></el-table-column
      ><el-table-column label="操作" width="240" fixed="right"
        ><template #default="{ row }"
          ><el-button link type="primary" @click="openDetail(row)">详情</el-button
          ><el-button
            v-if="row.certificationStatus === 2 || row.certificationStatus === 10"
            link
            type="success"
            @click="audit(row, true)"
            >通过</el-button
          ><el-button
            v-if="row.certificationStatus === 2 || row.certificationStatus === 10"
            link
            type="danger"
            @click="audit(row, false)"
            >拒绝</el-button
          ><el-button
            v-if="row.certificationStatus === 20"
            link
            type="primary"
            @click="openIncome(row)"
            >发放收益</el-button
          ></template
        ></el-table-column
      ></el-table
    ><Pagination
      :total="total"
      v-model:page="q.pageNo"
      v-model:limit="q.pageSize"
      @pagination="load"
  /></ContentWrap>
  <Dialog v-model="incomeVisible" title="发放创作者收益">
    <el-form label-width="90px">
      <el-form-item label="创作者"
        ><el-input :model-value="incomeForm.creatorName" disabled
      /></el-form-item>
      <el-form-item label="收益类型">
        <el-select v-model="incomeForm.incomeType" class="!w-100%">
          <el-option label="作品奖励" value="VIDEO" />
          <el-option label="活动补贴" value="ACTIVITY" />
          <el-option label="任务奖励" value="TASK" />
          <el-option label="品牌合作" value="BRAND" />
        </el-select>
      </el-form-item>
      <el-form-item label="收益标题"
        ><el-input v-model="incomeForm.title" maxlength="128"
      /></el-form-item>
      <el-form-item label="金额"
        ><el-input-number v-model="incomeForm.amount" :min="0.01" :max="999999.99" :precision="2"
      /></el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="incomeVisible = false">取消</el-button>
      <el-button type="primary" :loading="incomeSaving" @click="grantIncome">确认发放</el-button>
    </template>
  </Dialog>
  <Dialog v-model="detailVisible" title="创作者认证详情" width="820px">
    <el-descriptions :column="2" border>
      <el-descriptions-item label="编号">{{ detail.id ?? '--' }}</el-descriptions-item>
      <el-descriptions-item label="用户ID">{{ detail.userId ?? '--' }}</el-descriptions-item>
      <el-descriptions-item label="昵称">{{ detail.nickname || '--' }}</el-descriptions-item>
      <el-descriptions-item label="创作者类型">{{ creatorTypeText }}</el-descriptions-item>
      <el-descriptions-item label="认证类型">{{ certTypeText }}</el-descriptions-item>
      <el-descriptions-item label="认证状态"
        ><el-tag :type="certificationType(detail.certificationStatus)">{{
          names[detail.certificationStatus] || '未认证'
        }}</el-tag></el-descriptions-item
      >
      <el-descriptions-item label="真实姓名">{{ detail.realName || '--' }}</el-descriptions-item>
      <el-descriptions-item label="身份证号">{{ detail.idCardNo || '--' }}</el-descriptions-item>
      <el-descriptions-item label="所属机构">{{
        detail.organizationName || '--'
      }}</el-descriptions-item>
      <el-descriptions-item label="审核备注">{{
        detail.certificationRemark || '--'
      }}</el-descriptions-item>
      <el-descriptions-item label="粉丝">{{ detail.followerCount ?? 0 }}</el-descriptions-item>
      <el-descriptions-item label="累计获赞">{{ detail.totalLikeCount ?? 0 }}</el-descriptions-item>
      <el-descriptions-item label="信用分">{{ detail.creditScore ?? '--' }}</el-descriptions-item>
      <el-descriptions-item label="成长值">{{ detail.growthScore ?? '--' }}</el-descriptions-item>
      <el-descriptions-item label="等级">{{ detail.creatorLevel ?? '--' }}</el-descriptions-item>
      <el-descriptions-item label="发布权限">{{
        detail.publishEnabled ? '已开启' : '未开启'
      }}</el-descriptions-item>
      <el-descriptions-item label="营销权限">{{
        detail.marketingEnabled ? '已开启' : '未开启'
      }}</el-descriptions-item>
      <el-descriptions-item label="封禁至">{{
        formatTime(detail.bannedUntil)
      }}</el-descriptions-item>
      <el-descriptions-item label="创建时间">{{
        formatTime(detail.createTime)
      }}</el-descriptions-item>
      <el-descriptions-item label="更新时间">{{
        formatTime(detail.updateTime)
      }}</el-descriptions-item>
      <el-descriptions-item label="简介" :span="2"
        ><div
          class="max-h-120px overflow-auto whitespace-pre-wrap break-all"
          v-text="detail.introduction || '--'"
        ></div
      ></el-descriptions-item>
      <el-descriptions-item label="认证与展示材料" :span="2">
        <div class="flex flex-wrap gap-16px">
          <div v-for="item in detailMaterials" :key="item.label" class="w-180px">
            <el-image
              v-if="item.url"
              :src="item.url"
              :preview-src-list="item.previewList"
              :initial-index="item.previewIndex"
              preview-teleported
              fit="cover"
              class="h-120px w-180px border border-solid border-[var(--el-border-color)]"
            />
            <div
              v-else
              class="h-120px w-180px flex items-center justify-center border border-solid border-[var(--el-border-color)] text-12px text-#909399"
              >未上传</div
            >
            <div class="mt-4px text-center text-12px text-#909399">{{ item.label }}</div>
          </div>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <template #footer>
      <el-button @click="detailVisible = false">关闭</el-button>
    </template>
  </Dialog>
</template>
<script setup lang="ts">
import { Dialog } from '@/components/Dialog'
import { formatDate } from '@/utils/formatTime'
import * as Api from '@/api/shortvideo/content'
const message = useMessage(),
  loading = ref(false),
  list = ref<any[]>([]),
  total = ref(0),
  incomeVisible = ref(false),
  incomeSaving = ref(false),
  incomeForm = reactive<any>({}),
  q = reactive({ pageNo: 1, pageSize: 10, nickname: '', certificationStatus: undefined as any }),
  names: any = { 0: '未认证', 2: '待审核', 10: '审核中', 20: '已认证', 30: '已拒绝' }
const certificationType = (status: number) =>
  (status === 20
    ? 'success'
    : status === 30
      ? 'danger'
      : status === 2 || status === 10
        ? 'warning'
        : 'info') as any
async function load() {
  loading.value = true
  try {
    const d = await Api.creatorPage(q)
    list.value = d.list || []
    total.value = d.total || 0
  } finally {
    loading.value = false
  }
}
const query = () => {
  q.pageNo = 1
  load()
}
const resetQuery = () => {
  q.nickname = ''
  q.certificationStatus = undefined
  query()
}
async function audit(row: any, pass: boolean) {
  await Api.creatorAudit({ id: row.id, pass, remark: pass ? '认证通过' : '资料不符合认证要求' })
  message.success('处理成功')
  load()
}
function openIncome(row: any) {
  Object.assign(incomeForm, {
    creatorId: row.id,
    creatorName: row.nickname,
    incomeType: 'VIDEO',
    title: '优质作品奖励',
    amount: 0.01
  })
  incomeVisible.value = true
}
async function grantIncome() {
  if (!incomeForm.title?.trim() || !incomeForm.amount) return message.warning('请完整填写收益信息')
  incomeSaving.value = true
  try {
    await Api.incomeGrant(incomeForm)
    message.success('收益已发放并写入流水')
    incomeVisible.value = false
  } finally {
    incomeSaving.value = false
  }
}
const detailVisible = ref(false),
  detail = ref<any>({})
const creatorTypes: any = { NORMAL: '普通', PERSONAL: '个人', COMPANY: '企业' },
  certTypes: any = { ID_CARD: '身份证认证' }
const creatorTypeText = computed(
    () => creatorTypes[detail.value.creatorType] || detail.value.creatorType || '--'
  ),
  certTypeText = computed(
    () => certTypes[detail.value.certificationType] || detail.value.certificationType || '--'
  )
const formatTime = (value?: any) => (value ? formatDate(value) || '--' : '--')
const isImageUrl = (value?: string) =>
  !!value && /^(https?:\/\/|\/|data:image\/)/i.test(value.trim())
// 材料可能是历史占位串（非图片地址），只把能渲染的收进预览列表
const detailMaterials = computed(() => {
  const items = [
    { label: '身份证人像面', url: detail.value.idCardFrontUrl },
    { label: '身份证国徽面', url: detail.value.idCardBackUrl },
    { label: '头像', url: detail.value.avatarUrl },
    { label: '主页背景图', url: detail.value.backgroundUrl }
  ].map((item) => ({ ...item, url: isImageUrl(item.url) ? item.url : '' }))
  const previewList = items.map((item) => item.url).filter(Boolean)
  return items.map((item) => ({
    ...item,
    previewList,
    previewIndex: previewList.indexOf(item.url)
  }))
})
function openDetail(row: any) {
  detail.value = { ...row }
  detailVisible.value = true
}
onMounted(load)
</script>
